import React, { createContext, useContext, useMemo, useState } from 'react';
import { useMeContext } from 'modules/me';
import { useFeatureFlag } from 'modules/common/hooks';

type AutoPilotType = {
  isAutoPilotEnabled: boolean;
  setAutoPilotEnabled: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AutoPilotContext = createContext<AutoPilotType | null>(null);

export const useAutoPilotContext = (): AutoPilotType => {
  const val = useContext(AutoPilotContext);
  if (!val) {
    throw new Error(
      'useAutoPilotContext must be called within a AutoPilotContext'
    );
  }
  return val;
};

const AutoPilotContextProvider: React.FC = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const me = useMeContext();
  const isTiAutoAcceptUserSettingsEnabled = useFeatureFlag(
    'isTiAutoAcceptUserSettingsEnabled'
  );
  const [isAutoPilotEnabled, setAutoPilotEnabled] = useState(
    me?.isAutoAcceptEnabled || false
  );

  const value = useMemo(() => {
    return {
      isAutoPilotEnabled:
        isTiAutoAcceptUserSettingsEnabled && isAutoPilotEnabled,
      setAutoPilotEnabled
    };
  }, [isAutoPilotEnabled, isTiAutoAcceptUserSettingsEnabled]);

  return (
    <AutoPilotContext.Provider value={value}>
      {children}
    </AutoPilotContext.Provider>
  );
};

export default AutoPilotContextProvider;
